import React, { useState, useEffect } from 'react'
import {
  MenuOutlined,
  CloseOutlined,
  UserOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import {
  Drawer,
  Menu,
  Modal,
  Button,
  message,
  Dropdown,
  Avatar,
  Input,
  Form,
} from 'antd'
import { useNavigate } from 'react-router-dom'
import logo from '../Assets/LOGO.png'
import 'bootstrap/dist/css/bootstrap.min.css'
import { changePasswordAPI } from '../APIComponents/AdminApi'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'

const AdminHeader = () => {
  const [open, setOpen] = useState(false)
  const [userName, setUserName] = useState('')
  const [navItems, setNavItems] = useState([])
  const [modal, contextHolder] = Modal.useModal()
  const navigate = useNavigate()
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)
  const [passwordForm] = Form.useForm()
  const [loginType, setLoginType] = useState('')

  // ================= FULL MENU (ADMIN) =================
  const fullMenu = [
    { key: 'dashboard', label: 'Dashboard' },
    {
      key: 'masters',
      label: 'Masters',
      children: [
        { key: 'm1', label: 'Religion Master' },
        { key: 'm2', label: 'Cast Master' },
        { key: 'm3', label: 'Sub Cast Master' },
        { key: 'm4', label: 'Act & Section Master' },
        { key: 'm5', label: 'Building Master' },
        { key: 'm6', label: 'Floor Master' },
      ],
    },
    {
      key: 'forms',
      label: 'Forms',
      children: [
        { key: 'form1', label: 'Admission Form' },
        { key: 'form2', label: 'Parents Info/Documents' },
        { key: 'form3', label: 'F.I.R/Police Documents' },
        { key: 'form4', label: 'Room Allocation' },
        { key: 'form5', label: "Children's home visit (S I R)" },
        { key: 'form6', label: 'Namuna 7,9,18,20,22,45 (I C P)' },
        { key: 'form7', label: 'Educational Documents' },
        { key: 'form8', label: 'Medical Documents' },
        { key: 'form9', label: 'Girls Statement' },
        { key: 'form10', label: 'Case File' },
        { key: 'form11', label: 'Counsellor Form' },
        { key: 'form12', label: 'Discharge Form' },
      ],
    },
    {
      key: 'reports',
      label: 'Reports',
      children: [
        { key: 'r1', label: 'Admission Report' },
        { key: 'r2', label: 'Parent Report' },
        { key: 'r3', label: 'Fir & Police Report' },
        // { key: 'r4', label: 'Room Allocation Report' },
        { key: 'r5', label: 'Home Visit Report' },
        { key: 'r6', label: 'Namuna Form Report' },
        { key: 'r7', label: 'Education Document Report' },
        { key: 'r8', label: 'Medical Document Report' },
        { key: 'r9', label: 'Girl Statement Report' },
        { key: 'r10', label: 'Case File Report' },
        { key: 'r11', label: 'Counselling Report' },
        { key: 'r12', label: 'Discharge Report' },
      ],
    },
    {
      key: 'admin',
      label: 'Admin',
      children: [
        { key: 'a1', label: 'Menu Master' },
        { key: 'a2', label: 'Page Master' },
        { key: 'a3', label: 'Role Allocation' },
        { key: 'a4', label: 'User Creation' },
        // { key: 'a5', label: 'Extension Entry' },
      ],
    },
  ]

  // ================= ROUTES =================
  const routes = {
    dashboard: '/dashboard',
    m1: '/m1',
    m2: '/m2',
    m3: '/m3',
    m4: '/m4',
    m5: '/m5',
    m6: '/m6',
    form1: '/form1',
    form2: '/form2',
    form3: '/form3',
    form4: '/form4',
    form5: '/form5',
    form6: '/form6',
    form7: '/form7',
    form8: '/form8',
    form9: '/form9',
    form10: '/form10',
    form11: '/form11',
    form12: '/form12',
    r1: '/r1',
    r2: '/r2',
    r3: '/r3',
    r4: '/r4',
    r5: '/r5',
    r6: '/r6',
    r7: '/r7',
    r8: '/r8',
    r9: '/r9',
    r10: '/r10',
    r11: '/r11',
    r12: '/r12',
    a1: '/a1',
    a2: '/a2',
    a3: '/a3',
    a4: '/a4',
    // a5: '/a5',
  }

  const pageRouteMap = {
    1: '/m1',
    2: '/m2',
    3: '/m3',
    4: '/m4',
    5: '/m5',
    6: '/m6',
    7: '/form1',
    8: '/form2',
    9: '/form3',
    10: '/form4',
    11: '/form5',
    12: '/form6',
    13: '/form7',
    14: '/form8',
    15: '/form9',
    16: '/form10',
    17: '/form11',
    18: '/form12',
   
    19: '/a1',
    20: '/a2',
    21: '/a3',
    22: '/a4',
    // 23: '/a5',

    24: '/r1',
    25: '/r2',
    26: '/r3',
    27: '/r4',
    28: '/r5',
    29: '/r6',
    30: '/r7',
    31: '/r8',
    32: '/r9',
    33: '/r10',
    34: '/r11',
    35: '/r12',
  }

  const toggleDrawer = () => setOpen(!open)

  const navigateTo = (key) => {
    if (routes[key]) navigate(routes[key])
    else if (pageRouteMap[key]) navigate(pageRouteMap[key])
    setOpen(false)
  }

  // ================= LOAD USER DATA =================
  useEffect(() => {
    const storedUser = sessionStorage.getItem('userData')

    if (!storedUser) return

    const user = JSON.parse(storedUser)

    setLoginType(user.login_type)

    //  Show Username for ADMIN
    if (user.login_type === 'ADMIN') {
      setUserName(user.username || 'Admin')
      setNavItems(fullMenu)
    }

    //  Show Role Name for USER
    else if (user.login_type === 'USER') {
      setUserName(user.role?.role_name || user.username)

      if (user.menus && user.menus.length > 0) {
        const formattedMenus = user.menus
          .map((menu) => {
            //  Filter pages with at least one permission
            const filteredPages = menu.pages.filter(
              (page) =>
                page.is_view === 1 ||
                page.is_new === 1 ||
                page.is_edit === 1 ||
                page.is_delete === 1,
            )

            if (filteredPages.length === 0) return null

            return {
              key: menu.menu_name.toLowerCase(),
              label: menu.menu_name,
              children: filteredPages.map((page) => ({
                key: page.page_id.toString(),
                label: page.page_name,
              })),
            }
          })
          .filter(Boolean)

        setNavItems([
          { key: 'dashboard', label: 'Dashboard' },
          ...formattedMenus,
        ])
      } else {
        setNavItems([{ key: 'dashboard', label: 'Dashboard' }])
      }
    }
  }, [])

  // ================= LOGOUT =================
  const handleLogout = () => {
    modal.confirm({
      title: 'Are you sure you want to logout?',
      icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
      okText: 'Yes, Logout',
      cancelText: 'Cancel',
      centered: true,
      okButtonProps: { danger: true },
      onOk() {
        sessionStorage.removeItem('userData')
        message.success('Logged out successfully!')
        navigate('/')
      },
    })
  }

  // ================= CHANGE PASSWORD =================
  const ChangePassword = async (values) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem('userData'))

      const payload = {
        user_id: storedUser?.user_id || storedUser?.admin_id,
        current_password: values.currentPassword,
        new_password: values.newPassword,
      }

      const response = await axiosInstance.post(changePasswordAPI, payload)

      if (response.data === 'INVALID') {
        toast.warn('Invalid Data!')
      } else {
        toast.success('Password changed!')
        setIsPasswordModalOpen(false)
        passwordForm.resetFields()
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to change password')
    }
  }

  // ================= PROFILE MENU =================
  const profileMenu = {
    items: [
      {
        key: 'username',
        label: (
          <div style={{ padding: '8px 12px', fontWeight: 500 }}>
            👋 {userName}
          </div>
        ),
        disabled: true,
      },
      { type: 'divider' },
      ...(loginType !== 'ADMIN'
        ? [
            {
              key: 'changePassword',
              label: (
                <Button
                  type="text"
                  block
                  onClick={() => setIsPasswordModalOpen(true)}
                >
                  Change Password
                </Button>
              ),
            },
          ]
        : []),
      {
        key: 'logout',
        label: (
          <Button type="text" danger block onClick={handleLogout}>
            Logout
          </Button>
        ),
      },
    ],
  }

  return (
    <>
      {contextHolder}

      {/* Header */}
      <div className="top-header d-flex justify-content-between align-items-center px-4 py-2">
        <div className="d-flex align-items-center">
          <img src={logo} alt="NGO Logo" className="ngo-logo me-2" />
          <h3 className="ngo-name mb-0">ST. CRISPINS HOME, PUNE</h3>
        </div>

        <div className="d-none d-lg-block">
          <Dropdown menu={profileMenu} placement="bottomRight" arrow>
            <div
              className="d-flex align-items-center"
              style={{ cursor: 'pointer' }}
            >
              <span style={{ marginRight: 10, fontWeight: 500, fontSize: 16 }}>
                {userName}
              </span>
              <Avatar
                size={42}
                style={{ backgroundColor: '#f04e23' }}
                icon={<UserOutlined style={{ color: 'white' }} />}
              />
            </div>
          </Dropdown>
        </div>

        <div className="d-lg-none">
          {open ? (
            <CloseOutlined
              onClick={() => setOpen(false)}
              style={{ fontSize: 24 }}
            />
          ) : (
            <MenuOutlined
              onClick={() => setOpen(true)}
              style={{ fontSize: 24, color: 'gray' }}
            />
          )}
        </div>
      </div>

      {/* Desktop Menu */}
      <div className="d-none d-lg-block">
        <Menu
          mode="horizontal"
          className="custom-navbar"
          onClick={(e) => navigateTo(e.key)}
          items={navItems}
        />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          onClick={(e) => navigateTo(e.key)}
          items={navItems}
        />

        <div className="d-lg-none p-3 border-top">
          <div className="mb-3 fw-bold">👋 {userName}</div>

          {loginType !== 'ADMIN' && (
            <Button
              type="text"
              block
              onClick={() => {
                setIsPasswordModalOpen(true)
                setOpen(false)
              }}
            >
              Change Password
            </Button>
          )}

          <Button type="text" danger block onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </Drawer>

      {/* Change Password Modal */}
      <Modal
        title="Change Password"
        open={isPasswordModalOpen}
        onCancel={() => setIsPasswordModalOpen(false)}
        footer={null}
        centered
      >
        <Form form={passwordForm} layout="vertical" onFinish={ChangePassword}>
          <Form.Item
            label="Current Password"
            name="currentPassword"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[{ required: true, min: 6 }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('Passwords do not match'))
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Update Password
          </Button>
        </Form>
      </Modal>
    </>
  )
}

export default AdminHeader
